(function () {
    if (typeof window === "undefined" || window.__paperVideoControls) return
    window.__paperVideoControls = true

    var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M9.2 6.18c-.72-.44-1.65.08-1.65.92v9.8c0 .84.93 1.36 1.65.92l8.22-4.9a1.08 1.08 0 0 0 0-1.84l-8.22-4.9Z"/></svg>'
    var PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="7.45" y="6.1" width="3.35" height="11.8" rx="0.95" fill="currentColor"/><rect x="13.2" y="6.1" width="3.35" height="11.8" rx="0.95" fill="currentColor"/></svg>'
    var MAX = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>'
    var MIN = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" y1="10" x2="21" y2="3"/><line x1="3" y1="21" x2="10" y2="14"/></svg>'

    var dragging = null
    var io = null

    function frameOf(node) {
        return node && node.closest ? node.closest(".paper-video") : null
    }

    function videoOf(frame) {
        return frame ? frame.querySelector("video") : null
    }

    function timeLabel(seconds) {
        if (!isFinite(seconds) || seconds < 0) return "0:00"
        var total = Math.floor(seconds)
        var minutes = Math.floor(total / 60)
        var remainder = total % 60
        return minutes + ":" + String(remainder).padStart(2, "0")
    }

    function mute(video) {
        video.defaultMuted = true
        video.muted = true
        video.volume = 0
    }

    function sync(frame) {
        var video = videoOf(frame)
        if (!video) return
        if (!video.defaultMuted || !video.muted || video.volume !== 0) mute(video)
        var paused = video.paused
        if (paused) frame.setAttribute("data-paused", "")
        else frame.removeAttribute("data-paused")
        var play = frame.querySelector(".paper-video-play")
        if (play) {
            play.innerHTML = paused ? PLAY : PAUSE
            play.setAttribute("aria-label", paused ? "Play" : "Pause")
        }
        var duration = video.duration || 0
        var progress = duration > 0 ? Math.min(1, video.currentTime / duration) : 0
        var pct = progress * 100 + "%"
        var fill = frame.querySelector(".paper-video-track-fill")
        var knob = frame.querySelector(".paper-video-track-knob")
        var edge = frame.querySelector(".paper-video-progress-edge i")
        if (fill) fill.style.width = pct
        if (knob) knob.style.left = pct
        if (edge) edge.style.width = pct
        var time = frame.querySelector(".paper-video-time")
        if (time) time.textContent = timeLabel(video.currentTime)
        var track = frame.querySelector(".paper-video-track")
        if (track) {
            track.setAttribute("aria-valuemax", String(Math.floor(duration) || 0))
            track.setAttribute("aria-valuenow", String(Math.floor(video.currentTime)))
            track.setAttribute("aria-valuetext", timeLabel(video.currentTime))
        }
    }

    function togglePlay(frame) {
        var video = videoOf(frame)
        if (!video) return
        if (video.paused) startPlayback(frame, video)
        else video.pause()
    }

    function startPlayback(frame, video) {
        video.play().then(function () { sync(frame) }).catch(function () {})
    }

    function seek(frame, clientX) {
        var video = videoOf(frame)
        var track = frame.querySelector(".paper-video-track")
        if (!video || !track || !video.duration) return
        var rect = track.getBoundingClientRect()
        var ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width))
        video.currentTime = ratio * video.duration
        sync(frame)
    }

    function toggleFullscreen(frame) {
        var video = videoOf(frame)
        if (!video) return
        if (document.fullscreenElement) {
            if (document.exitFullscreen) document.exitFullscreen().catch(function () {})
            return
        }
        var request = frame.requestFullscreen || frame.webkitRequestFullscreen
        if (!document.fullscreenEnabled || !request) return
        Promise.resolve(request.call(frame)).catch(function () {})
        var webkitVideo = video
        if (!frame.requestFullscreen && webkitVideo.webkitEnterFullscreen) webkitVideo.webkitEnterFullscreen()
    }

    function hideUnavailableFullscreen() {
        if (document.fullscreenEnabled) return
        document.querySelectorAll(".paper-video-fullscreen").forEach(function (button) {
            button.hidden = true
        })
    }

    function observeAutoplay(video) {
        if (!io || !video || !video.autoplay) return
        io.observe(video)
    }

    function bindFrame(frame) {
        sync(frame)
        observeAutoplay(videoOf(frame))
    }

    function targetEl(event) {
        var node = event.target
        return node && node.nodeType === 1 ? node : node && node.parentElement
    }

    document.addEventListener("click", function (event) {
        var el = targetEl(event)
        if (!el || !el.closest) return
        var play = el.closest(".paper-video-play")
        if (play) {
            event.preventDefault()
            togglePlay(frameOf(play))
            return
        }
        var fs = el.closest(".paper-video-fullscreen")
        if (fs) {
            event.preventDefault()
            toggleFullscreen(frameOf(fs))
            return
        }
        if (el.closest(".paper-video-bar")) return
        var video = el.closest(".paper-video video")
        if (video) togglePlay(frameOf(video))
    })

    document.addEventListener("pointerdown", function (event) {
        var el = targetEl(event)
        if (!el || !el.closest) return
        var track = el.closest(".paper-video-track")
        if (!track) return
        event.preventDefault()
        var frame = frameOf(track)
        if (!frame) return
        dragging = frame
        frame.setAttribute("data-scrubbing", "")
        if (track.setPointerCapture) track.setPointerCapture(event.pointerId)
        seek(frame, event.clientX)
    })

    document.addEventListener("pointermove", function (event) {
        if (!dragging) return
        seek(dragging, event.clientX)
    })

    function endDrag() {
        if (!dragging) return
        dragging.removeAttribute("data-scrubbing")
        dragging = null
    }

    document.addEventListener("pointerup", endDrag)
    document.addEventListener("pointercancel", endDrag)

    document.addEventListener("keydown", function (event) {
        var el = targetEl(event)
        if (!el || !el.closest) return
        var frame = el.closest(".paper-video")
        if (!frame) return
        var video = videoOf(frame)
        if (!video) return
        if (event.key === " " || event.key === "k") {
            event.preventDefault()
            togglePlay(frame)
        } else if (event.key === "ArrowRight") {
            event.preventDefault()
            video.currentTime = Math.min(video.duration || 0, video.currentTime + 2)
            sync(frame)
        } else if (event.key === "ArrowLeft") {
            event.preventDefault()
            video.currentTime = Math.max(0, video.currentTime - 2)
            sync(frame)
        } else if (event.key === "f") {
            event.preventDefault()
            toggleFullscreen(frame)
        }
    })

    ;["play", "pause", "timeupdate", "loadedmetadata", "volumechange"].forEach(function (type) {
        document.addEventListener(type, function (event) {
            if (!event.target || event.target.tagName !== "VIDEO") return
            var frame = frameOf(event.target)
            if (frame) sync(frame)
        }, true)
    })

    document.addEventListener("fullscreenchange", function () {
        document.querySelectorAll(".paper-video").forEach(function (frame) {
            var button = frame.querySelector(".paper-video-fullscreen")
            if (!button || button.hidden) return
            var on = document.fullscreenElement === frame
            button.setAttribute("aria-label", on ? "Exit fullscreen" : "Enter fullscreen")
            button.innerHTML = on ? MIN : MAX
        })
    })

    if ("IntersectionObserver" in window) {
        io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return
                var video = entry.target
                if (video.autoplay && video.paused) startPlayback(frameOf(video), video)
                io.unobserve(video)
            })
        }, { rootMargin: "120px 0px" })
    }

    function bindProofDemo(stage) {
        if (!stage || stage.getAttribute("data-demo-bound")) return
        var launch = stage.querySelector(".proof-demo-launch")
        var loading = stage.querySelector(".proof-demo-loading")
        var win = stage.querySelector(".proof-demo-window")
        var status = stage.querySelector(".proof-demo-status")
        var statusText = status && status.querySelector("span")
        var closeBtn = stage.querySelector(".proof-demo-close")
        var fsBtn = stage.querySelector(".proof-demo-fullscreen")
        var openLink = stage.querySelector(".proof-demo-open")
        if (!launch || !loading || !win || !status || !closeBtn || !fsBtn || !openLink) return
        stage.setAttribute("data-demo-bound", "1")

        var iframe = null
        var observer = null
        var warmObserver = null
        var launched = false
        var ready = false
        var demoUrl = openLink.getAttribute("href") || "./demo/index.html"

        function setStatus(state, label) {
            status.setAttribute("data-state", state)
            if (statusText) statusText.textContent = label
            win.setAttribute("data-state", state === "preparing" ? "idle" : state)
        }

        function sendVisibility(visible) {
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage({ type: "unitree-go2-demo:visibility", visible: visible }, "*")
            }
        }

        function prepareDemo() {
            if (iframe) return
            if (warmObserver) {
                warmObserver.disconnect()
                warmObserver = null
            }
            setStatus("preparing", "Preparing")
            iframe = document.createElement("iframe")
            iframe.title = "PROOF Go2 perceptive locomotion online demo"
            iframe.allow = "fullscreen"
            iframe.allowFullscreen = true
            iframe.src = demoUrl
            iframe.addEventListener("load", function () {
                sendVisibility(false)
            })
            win.insertBefore(iframe, loading)
            observer = new IntersectionObserver(function (entries) {
                var entry = entries[0]
                sendVisibility(launched && !!(entry && entry.isIntersecting) && !document.hidden)
            }, { threshold: 0.05 })
            observer.observe(win)
        }

        function closeDemo() {
            launched = false
            ready = false
            sendVisibility(false)
            if (observer) {
                observer.disconnect()
                observer = null
            }
            if (iframe) {
                iframe.remove()
                iframe = null
            }
            loading.hidden = true
            launch.hidden = false
            closeBtn.hidden = true
            setStatus("idle", "Not loaded")
        }

        function launchDemo(event) {
            event.preventDefault()
            launched = true
            prepareDemo()
            launch.hidden = true
            closeBtn.hidden = false
            if (ready) {
                loading.hidden = true
                setStatus("running", "Running")
                sendVisibility(!document.hidden)
            } else {
                loading.hidden = false
                setStatus("loading", "Loading")
            }
        }

        launch.addEventListener("click", launchDemo)
        launch.addEventListener("pointerenter", prepareDemo, { once: true })
        launch.addEventListener("focus", prepareDemo, { once: true })
        closeBtn.addEventListener("click", closeDemo)
        fsBtn.addEventListener("click", function () {
            if (document.fullscreenElement) {
                if (document.exitFullscreen) document.exitFullscreen().catch(function () {})
                return
            }
            var request = win.requestFullscreen || win.webkitRequestFullscreen
            if (!document.fullscreenEnabled || !request) return
            Promise.resolve(request.call(win)).catch(function () {})
        })
        if (!document.fullscreenEnabled) fsBtn.hidden = true

        window.addEventListener("message", function (event) {
            if (!iframe || event.source !== iframe.contentWindow) return
            if (event.data && event.data.type === "unitree-go2-demo:ready") {
                ready = true
                if (launched) {
                    loading.hidden = true
                    setStatus("running", "Running")
                    sendVisibility(!document.hidden)
                } else {
                    setStatus("ready", "Ready")
                    sendVisibility(false)
                }
            }
            if (event.data && event.data.type === "unitree-go2-demo:activity" && launched) {
                if (event.data.state === "sleeping") setStatus("sleeping", "Sleeping")
                else if (event.data.state === "running") setStatus("running", "Running")
            }
            if (event.data && event.data.type === "unitree-go2-demo:progress" && event.data.label) {
                var hint = loading.querySelector("small")
                if (hint) hint.textContent = event.data.label
            }
        })
        document.addEventListener("visibilitychange", function () {
            sendVisibility(launched && !document.hidden)
        })
        if ("IntersectionObserver" in window) {
            warmObserver = new IntersectionObserver(function (entries) {
                if (!entries.some(function (entry) { return entry.isIntersecting })) return
                warmObserver.disconnect()
                warmObserver = null
                prepareDemo()
            }, { rootMargin: "1000px 0px" })
            warmObserver.observe(stage)
        }
        if ("requestIdleCallback" in window) {
            window.requestIdleCallback(prepareDemo, { timeout: 1500 })
        } else {
            window.setTimeout(prepareDemo, 1000)
        }
    }

    function start() {
        hideUnavailableFullscreen()
        document.querySelectorAll(".paper-video").forEach(bindFrame)
        document.querySelectorAll(".proof-demo-stage").forEach(bindProofDemo)
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start)
    else start()

    new MutationObserver(function (records) {
        records.forEach(function (record) {
            record.addedNodes.forEach(function (node) {
                if (!node || node.nodeType !== 1) return
                var frames = []
                if (node.matches && node.matches(".paper-video")) frames.push(node)
                if (node.querySelectorAll) node.querySelectorAll(".paper-video").forEach(function (frame) { frames.push(frame) })
                if (frames.length) hideUnavailableFullscreen()
                frames.forEach(bindFrame)
                var stages = []
                if (node.matches && node.matches(".proof-demo-stage")) stages.push(node)
                if (node.querySelectorAll) node.querySelectorAll(".proof-demo-stage").forEach(function (stage) { stages.push(stage) })
                stages.forEach(bindProofDemo)
            })
        })
    }).observe(document.documentElement, { childList: true, subtree: true })
})()
